import css from 'styled-jsx/css';
import getColor, { COLOR_DICTIONARY } from "@gc-npm/utils.enums.colors";

export default css`
  .filterContainer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: auto;
    min-height: 36px;
    width: 100%;
    padding-left: 6px;
    padding-right: 6px;
    cursor: pointer;
  }

  .filterBox {
    max-height: 220px;
    transition: max-height 0.4s ease-in;
    background-color: ${getColor(COLOR_DICTIONARY.GREY_100)};
    border-radius: 5px;
    padding-bottom: 12px;
    padding-top:6px;
  }

  input[type='radio'] {
    appearance: none;
    -webkit-appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid #6B6C6F;
    background-color: transparent;
    cursor: pointer;
    flex-shrink: 0;
    transition: border-color 0.15s ease, background-color 0.15s ease;
  }

  input[type='radio']:checked {
    border-color: ${getColor(COLOR_DICTIONARY.BLUE_HIGH)};
    background-color: ${getColor(COLOR_DICTIONARY.BLUE_HIGH)};
    box-shadow: inset 0 0 0 3px white;
  }

  input[type='radio']:focus-visible {
    outline: 2px solid ${getColor(COLOR_DICTIONARY.BLUE_HIGH)};
    outline-offset: 3px;
  }
`;
